import { render, staticRenderFns } from "./detalhe.vue?vue&type=template&id=4a4613fa&scoped=true"
import script from "./detalhe.vue?vue&type=script&lang=js"
export * from "./detalhe.vue?vue&type=script&lang=js"
import style0 from "./detalhe.vue?vue&type=style&index=0&id=4a4613fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4613fa",
  null
  
)

export default component.exports